import React, { Fragment, useEffect } from "react"
import { Router } from "react-router-dom"
import { createBrowserHistory } from "history"
import { getCookie } from "services/utils/cookie"
import { killSession } from "services/network/auth"
import ENV from "../src/envProperties"

import Root from "./Root"

import { logout } from "services/state/actions"

import { sendGtmEventPageView, sendGtmEventClick } from "services/utils/sendGtm"

window.log(`ENVIROMENT: ${process.env.NODE_ENV}`)

const history = createBrowserHistory({ basename: "/AreaClienteCorporativo" })

history.listen(() => {
  sendGtmEventPageView()
})

const currentPath = history.location.pathname

const verifyCustomer = () => {
  const customerSegment = getCookie("customerSegment") || false
  const customerKey = getCookie("customerKey")
  const documentNumber = customerKey ? atob(customerKey).length : ""
  const isCorporateCustomer =
    !customerSegment ||
    customerSegment === "CORPORATIVO" ||
    documentNumber >= 14

  if (!isCorporateCustomer) {
    logout()
    killSession()
    window.location.replace(
      `${ENV.BFF}/auth/oauth2/logout?location=${window.location.origin}`
    )
  }
}

const RouterApp = () => {
  useEffect(() => {
    sendGtmEventClick()

    if (currentPath !== "/logoff" && currentPath !== "/callback") {
      verifyCustomer()
    }
  }, [])

  return (
    <Fragment>
      <Router history={history}>
        <Root />
      </Router>
      <section id="toast-container"></section>
    </Fragment>
  )
}

export default RouterApp



// WEBPACK FOOTER //
// ./src/Router.js